export default "__VITE_ASSET__be071daf__"